export const es = {
  customMessage: 'Hola mundo'
}



// WEBPACK FOOTER //
// ./src/customization/SelfService/lang/es.js